import { render, staticRenderFns } from "./SetupOperadoras.vue?vue&type=template&id=7cb65ba8&"
import script from "./SetupOperadoras.vue?vue&type=script&lang=js&"
export * from "./SetupOperadoras.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports